module.exports = __webpack_public_path__ + "static/media/DMSans-Bold.5d9b1716.woff";